import styled from 'styled-components';

export const Form = styled.form`
  .input-group-text {
    background: none;
    border: none;
  }

  input {
    max-width: 100px;
  }

  td {
    input {
      display: inline-block;
    }
  }

  .options {
    .input-group-prepend {
      min-width: 60%;
    }
  }
`;
